import { render, staticRenderFns } from "./ColumnMapper.vue?vue&type=template&id=38a1c575&scoped=true"
import script from "./ColumnMapper.vue?vue&type=script&lang=js"
export * from "./ColumnMapper.vue?vue&type=script&lang=js"
import style0 from "./ColumnMapper.vue?vue&type=style&index=0&id=38a1c575&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1c575",
  null
  
)

export default component.exports